import { createElement } from 'react';
import PropTypes from 'prop-types';

import PCMAItem from '../../Cards/PCMAItem';
import TitleCard from '../../Cards/TitleCard';

import { SectionContainer } from './styles';

const cardResolver = component => {
  let card;
  switch (component) {
    case 'title-card':
      card = TitleCard;
      break;
    case 'pcma-item':
      card = PCMAItem;
      break;
    default:
      card = TitleCard;
      break;
  }
  return card;
};

const PCMAList = ({ data, theme = '' }) => {
  if (!data) return null;
  const { elements, columnCount } = data;

  return (
    <SectionContainer columnCount={columnCount} className={theme}>
      {elements &&
        elements.map(item => {
          const cardComponent = cardResolver(item.component);
          return createElement(cardComponent, {
            data: item,
            key: item.id,
          });
        })}
    </SectionContainer>
  );
};

PCMAList.propTypes = {
  data: PropTypes.shape().isRequired,
  theme: PropTypes.string,
};

export default PCMAList;
